// extracted by mini-css-extract-plugin
export var blockImage = "T_cV";
export var imageContainer = "T_bX";